function jsLoaded() {
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
}


function navTrigger() {
    const menuButton = document.getElementById('menu-button');
    const menu = document.getElementById('nav-main');
    const navAnchor = document.querySelectorAll('#main-menu a[href^="#"]');

    menuButton.addEventListener('click', () => {
        menuButton.classList.toggle('open')
        menu.classList.toggle('open')
    })

    for (let i = 0; i < navAnchor.length; i++) {
        navAnchor[i].addEventListener('click', () => {
            menuButton.classList.remove('open')
            menu.classList.remove('open')
        });
    }
}

function addMenuToggle() {
    const menuHasChildren = document.querySelectorAll('#main-menu .menu-item-has-children > a');
    for (let i = 0; i < menuHasChildren.length; i++) {
        let attrId = menuHasChildren[i].parentNode.getAttribute('id')
        let id = (attrId) ? attrId + '-toggle' : 'menu-toggle-' + i;
        menuHasChildren[i].insertAdjacentHTML('afterend', '<input type="checkbox" id="' + id + '">' +
            '<label for="' + id + '" class="menu-toggle">' +
            '<em aria-hidden="true"></em>' +
            '<span class="screen-reader-text">open menu</span>' +
            '</label>');
    }
}

function currentMenu() {
    const checkboxes = document.querySelectorAll('.current-menu-parent > input[type="checkbox"], .current-menu-ancestor > input[type="checkbox"]');
    for (checkbox of checkboxes) {
        checkbox.checked = true;
    }
}


const filters = document.querySelectorAll('.filter');
filters.forEach(filter => {

    filter.addEventListener('click', function () {

        let selectedFilter = filter.getAttribute('data-filter');
        let itemsToHide = document.querySelectorAll(`.projects .project:not([data-filter='${selectedFilter}'])`)
        let itemsToShow = document.querySelectorAll(`.projects [data-filter='${selectedFilter}']`)

        if (selectedFilter === 'all') {
            itemsToHide = [];
            itemsToShow = document.querySelectorAll('.projects [data-filter]')
        }

        itemsToHide.forEach(el => {
            el.classList.add('hide')
            el.classList.remove('show')
        });

        itemsToShow.forEach(el => {
            el.classList.remove('hide')
            el.classList.add('show')
        });

    });
});

function stickyFooter(){
    const nav = document.getElementById('navbar')
    const main = document.getElementById('content')
    const footer = document.getElementById('page-footer')
    if(window.innerHeight > (nav.offsetHeight + footer.offsetHeight)) {
        main.style.marginBottom = footer.offsetHeight + 'px'
        footer.style.position = 'fixed'
    }
}

/*
function modal() {
    const modals = document.querySelectorAll("[data-modal]");

    modals.forEach(function (trigger) {
        trigger.addEventListener("click", function (event) {
            event.preventDefault()
            const modal = document.getElementById(trigger.dataset.modal)
            modal.classList.add("open")
            const exits = modal.querySelectorAll(".modal-exit");
            exits.forEach(function (exit) {
                exit.addEventListener("click", function (event) {
                    event.preventDefault();
                    modal.classList.remove("open")
                })
            })
        })
    })
}
*/

document.addEventListener('DOMContentLoaded', () => {
    jsLoaded()
    navTrigger()
    stickyFooter()
    //modal()
    //addMenuToggle()
    //currentMenu()
}, false)

window.addEventListener("resize", function () {
    stickyFooter()
})

window.addEventListener('scroll', function () {

}, false)